export default function getSearchConfig(dispatcher) {
    return {
        onSearch: async (requestUrl) => {
            // Only fetch page again if the url has changed or is not cached
            const shouldSearch = !window.__ONSEARCH_URL || window.__ONSEARCH_URL !== requestUrl;
    
            if (shouldSearch) {
                // Update the current search url in the window object 
                window.__ONSEARCH_URL = requestUrl;
    
                // Gets the new page
                await dispatcher(requestUrl); 
            }
        }
    }
}